import React, { useEffect, useState } from "react";
import { ENV, PROD, SUB_DIRECTORY, UAT } from "../../common/constant";

const Footer = () => {
  const [user, setUserObj] = useState(null);
  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("userData"));
    if (user !== null) {
      let userObj = JSON.stringify(user);
      if (userObj !== null && userObj.length > 0) {
        setUserObj(userObj);
      }
    }
  }, [user]);

  return (
    <>
      <>
        {/* BEGIN: FOOTER */}
        {user != null && (
        <footer className="mt-5 fixed-bottom">
        
          <div className="bg-primary2 ">
            <div className="container">
              <div className="row text-white">
                <div className="col-12 text-center py-3">
                  <span className="text-white fs-7">
                  {/* <img
                  className="w-156 me-2"
                  src={`${SUB_DIRECTORY}/assets/images/pinclogo.jpg`}
                  title=""
                  alt="logo"
                />  */}
                <i className="fa fa-copyright" /> All Rights Reserved.
                    Copyright {new Date().getFullYear()} Pioneer Insurance &amp; Reinsurance Brokers
                    Pvt. Ltd.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </footer>
        )}
        {/* END: FOOTER */}
      </>
    </>
  );
};

export default Footer;
